import { defineComponent } from 'vue'
import { useResponsive } from '~/composables/useResponsive'
import type { IBreadcrumbProps } from './types'

const BreadcrumbStepper = defineComponent({
  props: ['steps', 'activeStep'],
  setup(props: IBreadcrumbProps) {
    const responsive = useResponsive()
    return () => {
      const steps = props.steps || []
      const activeStep = props.activeStep

      if (responsive.isSmall.value) {
        return (
          <div class="text-sm font-medium text-gray-500">
            Step {activeStep + 1} of {steps.length}
          </div>
        )
      }

      return (
        <ol class="flex items-center text-sm font-medium text-center dark:text-gray-400 sm:text-base dark:bg-gray-800 dark:border-gray-700 sm:space-x-4 rtl:space-x-reverse">
          {steps.map((step, i) => (
            <li
              class={`${i === activeStep ? 'text-primary-500' : 'text-gray-400'
                } flex items-center`}
            >
              <span
                class={`${i === activeStep ? 'border-primary-500' : 'border-gray-300'
                  } flex items-center justify-center w-5 h-5 me-2 text-xs border shrink-0 dark:border-primary-500`}
              >
                {i + 1}
              </span>
              <p class="font-medium">{step}</p>
              {i !== steps.length - 1 && (
                <svg
                  class="w-3 h-3 ms-2 sm:ms-4 rtl:rotate-180"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 12 10"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m7 9 4-4-4-4M1 9l4-4-4-4"
                  />
                </svg>
              )}
            </li>
          ))}
        </ol>
      )
    }
  }
})

export default BreadcrumbStepper
